var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgProcessSubDecisionTaskIcon = function SvgProcessSubDecisionTaskIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#595959",
    viewBox: "0 0 24 22",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.664 11.86-.222.232-.463-.443a.32.32 0 0 0-.534.162l-.412 1.822a.32.32 0 0 0 .397.38l1.802-.495a.32.32 0 0 0 .137-.54l-.463-.443.221-.232a2.246 2.246 0 0 0-.072-3.171l-2.78-2.656a2.246 2.246 0 0 0-3.171.072l.463.442a1.604 1.604 0 0 1 2.265-.051l2.78 2.656c.639.61.662 1.627.052 2.266M7.975 9.712l.221-.232.464.443a.32.32 0 0 0 .534-.161l.411-1.823a.32.32 0 0 0-.397-.379l-1.802.494a.32.32 0 0 0-.136.54l.463.444-.221.231a2.246 2.246 0 0 0 .072 3.172l2.78 2.656a2.246 2.246 0 0 0 3.17-.072l-.462-.443a1.604 1.604 0 0 1-2.266.052l-2.78-2.657a1.604 1.604 0 0 1-.051-2.265"
  })));
};
var Memo = /*#__PURE__*/memo(SvgProcessSubDecisionTaskIcon);
export default Memo;